import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { _3_DAYS } from '../../../constants/durations';
import { keys } from './keys';

export type SenderProvider = {
  id: string;
  name: string;
};

// The sender is recognized when their address belongs to a contact of one of the space's providers.
async function fetchSenderProvider(spaceId: string, fromEmail: string): Promise<SenderProvider | null> {
  const { data, error } = await apiClient
    .from('provider_contacts')
    .select('providers!inner(id, name, space_id)')
    .ilike('email', fromEmail.trim())
    .eq('providers.space_id', spaceId)
    .limit(1);

  if (error) {
    throw error;
  }

  const provider = data?.[0]?.providers;
  return provider ? { id: provider.id, name: provider.name } : null;
}

type Props = {
  spaceId: string;
  fromEmail: string | null | undefined;
  enabled?: boolean;
};

export function useGetSenderProvider(props: Props) {
  return useQuery({
    queryKey: keys.senderProvider(props.spaceId, props.fromEmail ?? ''),
    queryFn: () => fetchSenderProvider(props.spaceId, props.fromEmail!),
    enabled: Boolean(props.spaceId && props.fromEmail && (props.enabled ?? true)),
    staleTime: _3_DAYS,
  });
}
